module.exports = __webpack_public_path__ + "img/email.3c6f8b9f.svg";